import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["orgNumber"];

  // This controller assumes that the input used for orgnr is placed inside
  // a wrapper element with a unique id.
  connect() {
    this.createDropdownElement();
    this.hideOnClickOutside(this.addressDropdown.parentNode);           // Set up a listener for outside clicks.
  }

  hideOnClickOutside(element) {
    this.outsideClickListener = event => { if (!element.contains(event.target)) { this.hideDropdown(); } }
    document.addEventListener('click', this.outsideClickListener);
  }

  removeClickListener() { document.removeEventListener('click', this.outsideClickListener); }
  disconnect()          { this.removeClickListener(); }

  applyChanges(event) {
    this.currentlyUpdating = true; // This is to prevent hideChanges from reverting the changes when the dropdown is closed
    this.actOnChanges(event, (element2update, address_value) => { element2update.value = address_value; });
    this.hideDropdown();
    window.dispatchEvent(new Event('addressupdated'));
  }

  showChanges(event) {
    this.actOnChanges(event, (element2update, address_value) => {
      if(element2update.value != address_value) {
        element2update.dataset.originalValue = encodeURIComponent(element2update.value);
        element2update.classList.add('text-green-900', 'border-green-500', 'bg-green-50');
        element2update.value = address_value;
      }
    });
  }

  hideChanges(event) {
    this.actOnChanges(event, (element2update, address_value) => {
      var storedValue = decodeURIComponent(element2update.dataset.originalValue);
      if(storedValue != 'undefined') {
        element2update.classList.remove('text-green-900', 'border-green-500', 'bg-green-50');
        delete element2update.dataset.originalValue;                    // Clear the storedValue for next time
        if(this.currentlyUpdating) { return; }
        element2update.value = storedValue;
      }
    });
    this.currentlyUpdating = false;
  }

  actOnChanges(event, callbackFn) {
    const selectedItem = event.target.closest('.dropdown-item');
    const parentForm = selectedItem.closest('form');
    if (!parentForm) {
      console.log('orgNumber input target must be placed inside a form!');
      return;
    }
    for (const [key, address_value] of Object.entries(selectedItem.dataset)) {
      if(key != 'action') {
        var element2update = parentForm.getElementById('address-data--' + key);
        if(element2update) {
          callbackFn(element2update, address_value);
        }
      }
    }
  }

  createDropdownElement() {
    this.addressDropdown = document.createElement("div");
    this.addressDropdown.classList.add('dropdown');                     // Will get styling from dropdowns.css
    this.orgNumberTarget.parentNode.appendChild(this.addressDropdown);
  }

  showDropdown()  { this.addressDropdown.classList.add('active'); }
  hideDropdown()  { this.addressDropdown.classList.remove('active'); }
  hasResults()    { return this.addressDropdown.childNodes.length != 0; }
  focus()         { if(this.hasResults()) { this.showDropdown(); } }
  stopLoading()   { this.addressDropdown.classList.remove('loading'); }

  startLoading() {
    // Empty the list before we start
    this.addressDropdown.replaceChildren();
    this.showDropdown();
    this.addressDropdown.classList.add('loading');
  }

  // We only send a request to the server if number contains 10 or 12 digits
  showAddressList () {
    var countryDiv = document.getElementById('account-country')
    if (countryDiv !== null) {
      var accountCountry = countryDiv.children[2].children[0].title
      // For danish and norweigan locale its 'Sverige'
      if (accountCountry != 'Sverige' && accountCountry != 'Sweden') { this.hideDropdown(); return; }
    }
    const rinsedOrgNumber = this.orgNumberTarget.value.replace(/\D/, '')
    if (!((rinsedOrgNumber.length == 10) || (rinsedOrgNumber.length == 12))) { this.hideDropdown(); return; }
    this.startLoading();
    Rails.ajax({
      type: 'GET',
      url: `/clients/address_data?id_number=${this.orgNumberTarget.value}&dom_id=${this.orgNumberTarget.parentNode.id}`,
        success: (response) => { this.stopLoading(); },
        error: (response, status, request) => {
          this.stopLoading();
          this.addressDropdown.replaceChildren();
          var error_div = document.createElement("div");
          error_div.innerHTML = response.body.innerHTML;
          error_div.classList.add('flex', 'justify-center', 'px-3', 'text-sm', 'text-gray-500');
          this.addressDropdown.appendChild(error_div);
        }
    });
  }
}
